<template>
  <div>
    <el-dialog
      title="Add Currency"
      :visible.sync="dialogShow"
      :close-on-click-modal="false"
      :width="device === 'mobile' ? '95%' : ''"
      :before-close="handleClose"
      top="5vh"
    >
 
      <el-form
          :model="formData"
          ref="formData"
          label-width="250px"
          size="small"
          :rules="formDataRule"
          :label-position="device === 'mobile' ? 'top' : 'right'"
        >
          <el-form-item label="Currency" prop="currency">
            <el-select v-model="formData.currency" filterable @change="selectCurrency">
                <el-option
                  v-for="item in currencies"
                  :key="item.code"
                  :label="`${item.code}-${item.name}`"
                  :value="item.code">
                </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Name" prop="fullname">
            <el-input v-model="formData.fullname"></el-input>
          </el-form-item>
          
          <el-form-item label="Symbol" prop="symbol">
            <el-input v-model="formData.symbol"></el-input>
          </el-form-item>

          <el-form-item label="Country" prop="country">
            <el-select v-model="formData.country" filterable>
                <el-option
                  v-for="(item, index) in utility.country"
                  v-show="item.country_code"
                  :key="index"
                  :label="`${item.country_code}-${item.country_name}`"
                  :value="item.country_code">
                </el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="Type" prop="type">
            <el-select v-model="formData.type">
              <el-option label="Real" value="real"></el-option>
              <el-option label="Virtual" value="virtual"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="Status" prop="status">
            <el-select v-model="formData.status">
              <el-option label="Active" value="active"></el-option>
              <el-option label="Disable" value="disable"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Provider" prop="provider">
            <el-select v-model="formData.provider">
              <el-option label="Railsbank" value="railsbank"></el-option>
              <el-option label="Internal" value="internal"></el-option>
              <el-option label="IFX" value="ifx"></el-option>
              <el-option label="Lloyds" value="lloyds"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="Bankname" prop="bankname">
            <el-input v-model="formData.bankname"></el-input>
          </el-form-item>

          <el-form-item label="Account Name" prop="accountname">
            <el-input v-model="formData.accountname"></el-input>
          </el-form-item>

          <el-form-item label="Domestic Accountnumber" prop="domestic_accountnumber">
            <el-input v-model="formData.domestic_accountnumber"></el-input>
          </el-form-item>
          
          <el-form-item label="Domestic Sortcode/BIC" prop="domestic_sortcode">
            <el-input v-model="formData.domestic_sortcode"></el-input>
          </el-form-item>

          <el-form-item label="Domestic display for Virtual Ledger" prop="domestic_account_display">
            <el-checkbox v-model="formData.domestic_account_display" border></el-checkbox>
          </el-form-item>

          <el-form-item label="Account No./IBAN" prop="account">
            <el-input v-model="formData.account"></el-input>
          </el-form-item>
          
          <el-form-item label="Sortcode/BIC" prop="sortcode">
            <el-input v-model="formData.sortcode"></el-input>
          </el-form-item>
          
          <el-form-item label="Correspond Swift" prop="swiftcode" >
            <el-input v-model="formData.swiftcode"></el-input>
          </el-form-item>
        </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogShow = false">Cancel</el-button>
        <el-button type="primary" :loading="submiting" @click="submitCurrenc()">Submit</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addCurrency } from '@/api/currency'
import currenciesData from '@/utils/currencies.json'
import {findObject} from '@/utils'
import { getUtility } from "@/api/customer";
export default {
  computed: {
    device() {
      return this.$store.state.app.device;
    },
    username(){
      return this.$store.state.user.fullname;
    }
  },
  data(){
    return {
      dialogShow: false,
      submiting: false,
      projectUID: "",
      utility: {},
      currencies: currenciesData,
      formData: {},
      formDataRule:{
        currency: [{required: true, message: "Please select Currency", trigger: "blur"}],
        fullname: [{required: true, message: "Please enter name Currency", trigger: "blur"}],
      //symbol: [{required: true, message: "Please enter symbol", trigger: "blur"}],
        type: [{required: true, message: "Please select type", trigger: "blur"}],
        status: [{required: true, message: "Please select status", trigger: "blur"}],
        provider: [{required: true, message: "Please select provider", trigger: "blur"}],
        bankname: [{required: true, message: "Please enter bank name", trigger: "blur"}],
        accountname: [{required: true, message: "Please enter account name", trigger: "blur"}],
        account: [{required: true, message: "Please enter account", trigger: "blur"}],
        sortcode: [{required: true, message: "Please enter sortcode", trigger: "blur"}],
        swiftcode: [{required: true, message: "Please enter swiftcode", trigger: "blur"}],
      }
    }
  },
  methods:{
    getFormData(){
      return {
        "fullname": "",
        "currency": "",
        "country": "",
        "symbol": "",
        "type": "",
        "status": "",
        "provider": "",
        "bankname": "",
        "accountname": "",
        "account": "",
        "sortcode": "",
        "swiftcode": "",
        "domestic_accountnumber": "",
        "domestic_sortcode": "",
        "domestic_account_display": true
      }
    },
    getUtility() {
      getUtility().then(({ result, data }) => {
        if (result) {
          this.utility = data;
          this.utility.country.splice(113, 1) //remove country no code
        }
      });
    },
    openDialog(project){
      this.projectUID = project
      this.formData = this.getFormData();
      this.dialogShow = true
    },

    addCurrency(){
      this.submiting = true;
      addCurrency(this.projectUID, this.formData).then(({ result }) => {
        this.submiting = false;
        if (result) {
          this.dialogShow = false;
          this.$notify({
            title: "Success",
            message: `Issue card successfully`,
            type: "success",
            duration: 2000,
          });
          this.$emit('submited')
        }
      });
    },

    submitCurrenc(){
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.addCurrency()
        }else{
          console.log("error submit!!");
          return false;
        }
       });
    },
    handleClose(){
      this.dialogShow = false;
    },
    selectCurrency(currency){
      let o = findObject(this.currencies, currency, 'code')
      this.formData.symbol = o.symbol
      this.formData.fullname = o.name
    }
  },
  created() {
    this.getUtility();
  },
}
</script>

<style>

</style>